module.exports = __webpack_public_path__ + "img/information.f0b61716.png";